// @flow
import React from "react";
import "./PriceOverview.scss";
import type Price from "../../../models/Price";
import {currencyConverter} from "../../../helper/currency";
import type {SlyCustomer, SpsCustomer} from "../../../reducers/couponReducer";
import SpsCouponContainer from "../../../container/checkout/dataSummaryBox/SpsCouponContainer";
import SlyCouponContainer from "../../../container/checkout/dataSummaryBox/SlyCouponContainer";
import {useTranslation} from "react-i18next";

type PriceOverviewProps = {
	withMounting: boolean,
	shippingCost: Price,
	coupon: Price,
	orderItemsPriceSum: Price,
	total: Price,
    hideSlyCoupon: boolean,
	minOrderValue: Price,
	spsCustomer: ?SpsCustomer,
	slyCustomer: ?SlyCustomer,
	eligibleAmount: Price,
}

export const PriceOverview = (props: PriceOverviewProps) => {
	const {t} = useTranslation();

    return (
		<div className="hpm-total">
			<span className="hpm-totalTitle">{t("cart.calculation.price")}</span>
			<table>
				<tbody>
					<tr>
						<td><span>{t("cart.calculation.subtotal")}</span></td>
						<td className="hpm-right">{currencyConverter(props.orderItemsPriceSum)}</td>
					</tr>
					<tr>
						<td><span>{t("cart.calculation.shippingCosts")}</span></td>
						<td className="hpm-right">{currencyConverter(props.shippingCost)}</td>
					</tr>
					{props.coupon &&
						<tr>
							<td><span>{t("cart.coupon.coupon")}</span></td>
							<td className="hpm-right">
								-{currencyConverter({
								value: Math.max(
									-(props.shippingCost.value + props.orderItemsPriceSum.value),
									props.eligibleAmount.value
								),
								currency: props.orderItemsPriceSum.currency
							})}
							</td>
						</tr>
					}
					<tr className={"hpm-sum"}>
						<td><span>{t("cart.calculation.priceAfterTaxes")}</span></td>
						<td className="hpm-right">{currencyConverter(props.total)}</td>
					</tr>
					{props.minOrderValue &&
						<tr className={"hpm-minOrderValue"}>
							<td><span>{t("cart.coupon.minOrderValueLabel")}</span></td>
							<td className="hpm-right">{currencyConverter(props.minOrderValue)}</td>
						</tr>
					}
				</tbody>
			</table>
			{props.spsCustomer && <SpsCouponContainer/>}
			{props.slyCustomer && !props.hideSlyCoupon && <SlyCouponContainer/>}
			<p>
				<small>
					{props.withMounting && t("cart.calculation.montageHint")}
				</small>
			</p>
		</div>
	);
};

export default PriceOverview;
